export const SAVINGS_CALCULATOR_REDUX_FORM_NAME = 'personal-loans-savings-calculator'
export const LOAN_AMOUNT_FIELD_NAME = 'pl-calculator-amount'
export const LOAN_AMOUNT_FIELD_LABEL = 'Enter your loan amount'
export const LOAN_AMOUNT_CEILING = 100000
export const LOAN_AMOUNT_FLOOR = 600
export const SAVINGS_MULTIPLIER = 0.191
export const CALCULATOR_DISCLOSURE_MODAL_NAME = 'calculator-disclosure'
